import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Select, DatePicker } from 'components';
import { ClientQuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { GoogleMapsIcon, ArrowLeft } from 'assets/icons';
import { PaymentImage, BFCLogo, StripeLogo } from 'assets/img';
import { connect } from 'react-redux';
import axios from 'axios';
import { Elements, CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Header from 'screens/header';

declare var Stripe: any;
const stripe = Stripe(process.env.REACT_APP_STRIPE_KEY || '');

interface Props extends RootState {
	onClose?: any;
	item?: any;
	item_to_url?: any;
	stripe?: any;
	elements?: any;
	TotalContainer?: React.ReactNode;
	Marquee?: React.ReactNode;
	submit?: any;
}

class ModalPayment extends React.Component<Props> {

	elements: any;

	state = {
		item: this.props.item,
		banks: [],
		payment_methods: [],
		bank_accounts: [],
		form: {
			payment_method_id: Constants.PAYMENT_METHODS.MOVIL,
			payment_email: '',
			payment_phone: '',
			payment_date: '',
			payment_bank_id: '',
			payment_reference: '',
			payment_photo: '',
			payment_bank_account_id: '',
			discount_code: '',
			payment_name: ''
		},
		is_corporate: false,
		captcha_token: '',
		captcha_ekey: ''
	}

	async componentDidMount() {
		this.load();

		if (Globals.checkIfCorporate(this.props.user)) {
			await this.setState({
				is_corporate: true,
				form: {
					...this.state.form,
					payment_method_id: Constants.PAYMENT_METHODS.CORPORATE
				}
			});
		}
	}

	componentDidUpdate(prevProps: any, prevState: any) {
		if (this.props.item != prevProps.item) {
			this.setState({
				item: this.props.item
			});
		}
	}
	load = async () => {
		const res: any = await ClientQuoteService.client.getBanks();

		const { ZELLE, CASH2, MOVIL, TRANSFER, STRIPE } = Constants.PAYMENT_METHODS;

		this.setState({
			banks: res.banks,
			payment_methods: res.payment_methods.filter((i: any) => [ZELLE,TRANSFER, CASH2, STRIPE, MOVIL].indexOf(i.id) != -1),
			bank_accounts: res.bank_accounts
		},() => {
			const quantity_of_days = this.state.item.multiples_dates ? this.state.item.days_selected.length : 1;
			const price = (this.state.item?.price * quantity_of_days) + this.state.item.surcharges + this.state.item.journey_surcharge;

			if (price <= 0) {
				this.submit(true);
			}
		});
	}

	submit = async (withoutPaymentMethod = false) => {
		let token = null;

		if (!this.state.captcha_token && this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE) {
			Globals.showError("Por favor, resuelva el captcha para continuar");
			return;
		}

		if (!withoutPaymentMethod) {
			if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2) {
				if (!this.state.form.payment_photo) {
					Globals.showError("Debe ingresar la foto de los billetes");
					return;
				}
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL) {
				if (!this.state.form.payment_date) {
					Globals.showError("Debe ingresar la fecha del pago");
					return;
				}

				if (!this.state.form.payment_phone) {
					Globals.showError("Debe ingresar el teléfono del pago móvil");
					return;
				}

				if (!this.state.form.payment_bank_id) {
					Globals.showError("Debe ingresar el banco del pago móvil");
					return;
				}

				if (!this.state.form.payment_reference) {
					Globals.showError("Debe ingresar el número de referencia");
					return;
				}

				if (!this.state.form.payment_photo) {
					Globals.showError("El comprobante de pago es requerido para este método de pago");
					return;
				}
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER) {
				if (!this.state.form.payment_date) {
					Globals.showError("Debe ingresar la fecha del pago");
					return;
				}

				if (!this.state.form.payment_bank_id) {
					Globals.showError("Debe ingresar el banco de la transferencia");
					return;
				}

				if (!this.state.form.payment_reference) {
					Globals.showError("Debe ingresar el número de referencia");
					return;
				}

				if (!this.state.form.payment_photo) {
					Globals.showError("Debe ingresar la foto del pago");
					return;
				}
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE) {
				if (!this.state.form.payment_name) {
					Globals.showError("Persona que realizó el pago");
					return;
				}

				if (!this.state.form.payment_date) {
					Globals.showError("Debe ingresar la fecha de pago");
					return;
				}
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.BFC) {
				return;
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH) {
				if (!this.state.form.payment_bank_account_id) {
					Globals.showError("Debe ingresar la cuenta bancaria");
					return;
				}

				if (!this.state.form.payment_date) {
					Globals.showError("Debe ingresar la fecha del pago");
					return;
				}

				if (!this.state.form.payment_reference) {
					Globals.showError("Debe ingresar el número de referencia");
					return;
				}
			}
			else if (this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE) {
			    Globals.setLoading();

			    try {
			    	const card = this.props.elements.getElement('card');
			    	const response = await stripe.createToken(card);

			    	token = response?.token?.id;
			    }
			    catch(e) {
			    	console.log(e);
			    	Globals.quitLoading();
			    	Globals.showError("Lo sentimos, no se pudo procesar su pago");
			    	return;
			    }		    
			}
		}

		const is_stripe = this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE;

		const data = {
			...this.state.item,
			...this.state.form,
			hasFile: true,
			withoutLoading: is_stripe,
			way: 'web',
			// @ts-ignore,
			payment_photo: this.state.form.payment_photo?.value || '',
			payment_date: this.state.form.payment_date && moment(this.state.form.payment_date).format('YYYY-MM-DD'),
			token,
			subuser_id: this.props.user?.owner_id != null ? this.props.user?.id : '',
			captcha_token: this.state.captcha_token,
			captcha_ekey: this.state.captcha_ekey
		}
		console.log('data: ', data)

		const res: any = await ClientQuoteService.client.create({
			...this.state.item,
			...this.state.form,
			hasFile: true,
			withoutLoading: is_stripe,
			way: 'web',
			// @ts-ignore,
			payment_photo: this.state.form.payment_photo?.value || '',
			payment_date: this.state.form.payment_date && moment(this.state.form.payment_date).format('YYYY-MM-DD'),
			token,
			subuser_id: this.props.user?.owner_id != null ? this.props.user?.id : '',
			captcha_token: this.state.captcha_token,
			captcha_ekey: this.state.captcha_ekey
		}).catch(err => {
			Globals.quitLoading();
		});

		if (is_stripe)
			Globals.quitLoading();

		if (res?.result) {
			this.props.onClose(true);
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	verifyCaptcha = (captcha_token: string, captcha_ekey: string) => {
		this.setState({
			captcha_token,
			captcha_ekey
		});
	}
	
	render() {
		const payment_movil: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.MOVIL);
		const bank_account: any = this.state.bank_accounts.find((i: any) => i.id == this.state.form.payment_bank_account_id);
		const transfer: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.TRANSFER);
		const payment_zelle: any = this.state.payment_methods.find((i: any) => i.id == Constants.PAYMENT_METHODS.ZELLE);
		const random_number = Globals.randomString(6);

		const quantity_of_days = this.state.item.multiples_dates ? this.state.item.days_selected.length : 1;
		const price = (this.state.item?.price * quantity_of_days) + this.state.item.surcharges + this.state.item.journey_surcharge;
		const TotalContainer: any = this.props.TotalContainer;
		const Marquee: any = this.props.Marquee;

		return (
			<>
				<Header
					withLayout={ true }
					useSocials={ true }
					withoutMenu={ true }
				/>
				<div id="modal-quotes-payment">
					<div className="row">
						<div className="col-md-8">
							<div className="row-gray-price">
								<h5 className="header-price">
									<a href="#" className="link-close" onClick={ (e: any) => {
										e.preventDefault();
										this.props.onClose();
									} }>
										<img src={ ArrowLeft } />
									</a>
									Método de Pago
								</h5>

								<div style={{ padding: '20px' }}>
									<div className="row row-payment-methods">
										{
											!this.state.is_corporate && this.state.payment_methods.map((item: any) => {
												return (
													<>
														{
															item != null && (
																<div className="col-lg-4">
																	<button className={ `btn btn-blue ${ this.state.form.payment_method_id == item.id ? 'active' : '' }` } onClick={ () => this.setState({
																		form: {
																			...this.state.form,
																			payment_method_id: item.id
																		}
																	}) }>
																		<img src={ Constants.BASE_PUBLIC + item.photo } />
																		{ item.name }
																	</button>
																</div>
															)
														}
													</>
												)
											})
										}
									</div>

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CORPORATE && (
											<React.Fragment>			
												<h5 className="title-corporate">Confirmación de Orden de Servicio</h5>
												<div className="row row-corporate">
													<div className="col-md-8">
														<p className="text-corporate">Realizando la confirmación se dara inicio al proceso de solicitud de limpieza</p>
													</div>
													<div className="col-md-4 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
													</div>
												</div>
											</React.Fragment>						
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.MOVIL && (
											<React.Fragment>			
												<div className="row row-payments">
													<div className="col-md-8">
														<h6>Datos para el pago</h6>
														<p>{ payment_movil?.bank?.name } - { payment_movil?.bank?.code }</p>
														<p>{ payment_movil?.document_type?.name + payment_movil?.document }</p>
														<p>{ payment_movil?.phone }</p>
													</div>
													<div className="col-md-4 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
													</div>
												</div>						
												<div className="row">
													<div className="col-12">
														<h5>Confirmar pago</h5>
														<Select
															label="Banco"
															name="payment_bank_id"
															onChange={ (e: any) => this.change(e) }
															value={ this.state.form.payment_bank_id }
															options={ this.state.banks.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
													<div className="col-md-6">
														<DatePicker
															label="Fecha"
															maxDate={ moment().toDate() }
															onChange={ (text: string) => {
																this.change({
																	target: {
																		value: text,
																		name: 'payment_date'
																	}
																});
															} }
															value={ this.state.form.payment_date }
														/>
													</div>
													<div className="col-md-6">
														<Input
															type="number"
															color="white"
															value={ this.state.form.payment_phone }
															name="payment_phone" 
															label="Teléfono"
															maxLength={ 11 }
															onChange={ this.change } />
													</div>
													<div className="col-12">
														<PaperClip
															value={ this.state.form.payment_photo }
															successText={ `Foto Adjuntada` }
															pendingText={ `Subir comprobante` }
															onChange={ (e: any) => {
																this.setState({
																	form: {
																		...this.state.form,
																		payment_photo: e.target
																	}
																})
															} } />
													</div>
													<div className="col-12">
														<Input
															className="reference"
															type="number"
															color="white"
															value={ this.state.form.payment_reference }
															name="payment_reference" 
															maxLength={ 4 }
															placeholder="Últimos 4 dígitos de referencia"
															onChange={ this.change } />
													</div>													
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE && (
											<React.Fragment>	
												<div className="row row-payments">
													<div className="col-md-12 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price) }</p>
													</div>
												</div>
												<div className="row">		
													<div className="col-md-12">
														<div className="container-logo-stripe">
															<img src={ StripeLogo } />
														</div>
													</div>
													<div className="col-md-12">
														<div className="card-element-stripe">
															<CardElement options={{
																hidePostalCode: true
															}} />
														</div>
													</div>
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.TRANSFER && (
											<React.Fragment>			
												<div className="row row-payments">
													<div className="col-md-8">
														<h6>Datos para el pago</h6>
														<p>{ transfer?.account_name }</p>
														<p>{ transfer?.bank?.name } - { transfer?.bank?.code }</p>
														<p>{ transfer?.account_number }</p>
														<p>{ transfer?.document_type?.name + transfer?.document }</p>
													</div>
													<div className="col-md-4 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
													</div>
												</div>						
												<div className="row">
													<div className="col-12">
														<h5>Confirmar pago</h5>
													</div>
													<div className="col-md-6">
														<Select
															label="Banco"
															name="payment_bank_id"
															onChange={ (e: any) => this.change(e) }
															value={ this.state.form.payment_bank_id }
															options={ this.state.banks.map((i: any) => {
																return {
																	value: i.id,
																	label: i.name
																}
															}) } />
													</div>
													<div className="col-md-6">
														<DatePicker
															label="Fecha"
															maxDate={ moment().toDate() }
															onChange={ (text: string) => {
																this.change({
																	target: {
																		value: text,
																		name: 'payment_date'
																	}
																});
															} }
															value={ this.state.form.payment_date }
														/>
													</div>
													<div className="col-12">
														<PaperClip
															value={ this.state.form.payment_photo }
															successText={ `Foto Adjuntada` }
															pendingText={ `Imagen del pago` }
															onChange={ (e: any) => {
																this.setState({
																	form: {
																		...this.state.form,
																		payment_photo: e.target
																	}
																})
															} } />
													</div>
													<div className="col-12">
														<Input
															className="reference"
															type="number"
															color="white"
															value={ this.state.form.payment_reference }
															name="payment_reference" 
															maxLength={ 4 }
															placeholder="Últimos 4 dígitos de referencia"
															onChange={ this.change } />
													</div>
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.ZELLE && (
											<React.Fragment>
												<div className="row row-payments">
													<div className="col-md-8">
														<h6>Datos para el pago</h6>
														<p>{ payment_zelle?.email }</p>
													</div>
													<div className="col-md-4 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price) }</p>
													</div>
												</div>
												<div className="row">
													<div className="col-12">
														<h5>Confirmar pago</h5>
													</div>
													<div className="col-md-6">
														<DatePicker
															label="Fecha de pago"
															maxDate={ moment().toDate() }
															onChange={ (text: string) => {
																this.change({
																	target: {
																		value: text,
																		name: 'payment_date'
																	}
																});
															} }
															value={ this.state.form.payment_date }
														/>
													</div>
													<div className="col-md-6">
														<Input
															color="white"
															label="Persona que realizó el pago"
															value={ this.state.form.payment_name }
															name="payment_name" 
															placeholder="Nombre"
															onChange={ this.change } />
													</div>
													<div className="col-12">
														<PaperClip
															value={ this.state.form.payment_photo }
															successText={ `Foto Adjuntada` }
															pendingText={ `Imagen del pago` }
															onChange={ (e: any) => {
																this.setState({
																	form: {
																		...this.state.form,
																		payment_photo: e.target
																	}
																})
															} } />
													</div>
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.BFC && (
											<React.Fragment>			
												<div className="row row-payments">
													<div className="col-md-8">
														<div className="container-logo-bfc">
															<img src={ BFCLogo } />
														</div>
													</div>
													<div className="col-md-4 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</p>
													</div>
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH && (
											<React.Fragment>			
												<div className="row row-payments">
													{
														bank_account && (
															<div className="col-md-12" style={{ marginBottom: '20px' }}>
																<h6>Datos para el pago</h6>
																<p>{ bank_account?.number }</p>
																<p>{ bank_account?.bank?.name } - { bank_account?.bank?.code }</p>
															</div>
														)
													}
												</div>
												<div className="row">
													<div className="col-md-6">
														<Select
															label="Cuenta bancaria"
															name="payment_bank_account_id"
															onChange={ (e: any) => this.change(e) }
															value={ this.state.form.payment_bank_account_id }
															options={ this.state.bank_accounts.map((i: any) => {
																return {
																	value: i.id,
																	label: i.number + ' - ' + i.bank?.name
																}
															}) } />
													</div>
													<div className="col-md-6 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price) }</p>
													</div>
													<div className="col-md-12">
														<DatePicker
															label="Fecha"
															maxDate={ moment().toDate() }
															onChange={ (text: string) => {
																this.change({
																	target: {
																		value: text,
																		name: 'payment_date'
																	}
																});
															} }
															value={ this.state.form.payment_date }
														/>
													</div>
													<div className="col-12">
														<Input
															className="reference"
															type="number"
															color="white"
															value={ this.state.form.payment_reference }
															name="payment_reference" 
															placeholder="Número de confirmación"
															onChange={ this.change } />
													</div>
												</div>
											</React.Fragment>
										)
									}

									{
										// @ts-ignore
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.CASH2 && (
											<>
												<div className="row row-payments">
													<div className="col-md-12 text-right">
														<h6>Total a pagar</h6>
														<p className="total">{ Globals.formatMiles(price) }</p>
													</div>
												</div>
												<div className="row">
													<div className="col-12">
														<h5>Confirmar pago</h5>
													</div>
													<div className="col-12">
														<PaperClip
															value={ this.state.form.payment_photo }
															successText={ `Foto Adjuntada` }
															pendingText={ `Imagen de los billetes` }
															onChange={ (e: any) => {
																this.setState({
																	form: {
																		...this.state.form,
																		payment_photo: e.target
																	}
																})
															} } />
													</div>
												</div>
											</>
										)
									}

									{
										this.state.form.payment_method_id == Constants.PAYMENT_METHODS.STRIPE && (
											<div className="text-center">
												{/*
												// @ts-ignore*/}
												<HCaptcha sitekey={ process.env.REACT_APP_CAPTCHA_KEY } onVerify={ (token,ekey) => this.verifyCaptcha(token, ekey) } />
											</div>
										)
									}

									<div className="row row-buttons-submit">
										<div className="col-md-12 text-center">
											{
												this.state.form.payment_method_id == Constants.PAYMENT_METHODS.BFC && (
													<form method='POST' action={ process.env.REACT_APP_BFC_URL }>
														<input type="hidden" name="MONTOBOTON" value={ Globals.convert(this.props.item?.price,this.props.conversion?.amount || 0).toFixed(2) } />
														<input type="hidden" name="urlRedirec" value={ 'api/client/quotes/process-bfc?' + this.props.item_to_url } />
														<input type="hidden" name="NROORDEN" value={ random_number } />
														<input type="hidden" value={ process.env.REACT_APP_BFC_KEYID } name="KEYID" />
												        <input type="hidden" value={ process.env.REACT_APP_BFC_PRIVATEKEY } name="PRIVATEKEY" />
												        <input type="hidden" value={ process.env.REACT_APP_BFC_JWT } name="JWT" />
												        <input type="hidden" value="B" name="MODOPAGO" />
												        <button className="btn btn-save" type="submit">
															Confirmar
														</button>
												    </form>
												)
											}
											{
												this.state.form.payment_method_id != Constants.PAYMENT_METHODS.BFC && (
													<button className="btn btn-save" onClick={ () => this.submit() }>
														Verificar
													</button>
												)
											}								
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-4">
							<TotalContainer withoutSubmit={ true } />

							{
								!this.state.item?.multiples_dates && (
									<div className="row row-gray-price" style={{ marginTop: '20px' }}>
										<h5 className="header-price">Código de Descuento</h5>
										
										<div className="col-12">
											<div className="row">
												<div className="col-8">
													<Input
														color="white"
														value={ this.state.form.discount_code }
														name="discount_code" 
														className="input-code"
														placeholder="Código de Descuento"
														onChange={ this.change } />
												</div>
												<div className="col-4">
													<button className="btn btn-code" onClick={ () => this.props.submit(this.state.form.discount_code) }>
														Aplicar
													</button>
												</div>
											</div>
										</div>
									</div>
								)
							}
						</div>
					</div>

					<div className="text-center">
						<Marquee />
					</div>
				</div>
			</>
		)
	}
}

const _ModalPayment = connect((state: RootState) => {
	return {
		conversion: state.conversion,
		user: state.user
	}
})(ModalPayment);

export default function StripeContainer(props: Props) {
  return (
  	<Elements stripe={ stripe }>
	    <ElementsConsumer>
	      {({stripe, elements}) => (
	        <_ModalPayment { ...props } stripe={ stripe } elements={ elements } />
	      )}
	    </ElementsConsumer>
	</Elements>
  )
}